import React from 'react';

const AppointmentIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
      <g id="Group_1965" data-name="Group 1965" transform="translate(0.178 0.484)">
        <path id="Subtraction_62" data-name="Subtraction 62" d="M11.94,9.439H2.48A2.293,2.293,0,0,1,0,7.465V1.974A2.293,2.293,0,0,1,2.48,0h3.4V3.178a1.037,1.037,0,1,0,2.075,0V0H11.94A2.82,2.82,0,0,1,13.7.577a1.774,1.774,0,0,1,.723,1.4V7.465A2.294,2.294,0,0,1,11.94,9.439Z" transform="translate(0.363 6.519)" fill="none" stroke="currentColor" strokeWidth="1"/>
        <g id="Ellipse_486" data-name="Ellipse 486" transform="translate(-0.178 -0.484)" fill="none" stroke="currentColor" strokeWidth="1">
          <circle cx="3" cy="3" r="3" stroke="none"/>
          <circle cx="3" cy="3" r="2.5" fill="none"/>
        </g>
        <g id="Ellipse_487" data-name="Ellipse 487" transform="translate(8.822 -0.484)" fill="none" stroke="currentColor" strokeWidth="1">
          <circle cx="3" cy="3" r="3" stroke="none"/>
          <circle cx="3" cy="3" r="2.5" fill="none"/>
        </g>
      </g>
    </svg>
  );
};

export default AppointmentIcon;
